/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Col, Input, Row } from 'antd';
import InputColor from 'react-input-color';

const ColorPicker = ({
  defaultColor,
  value,
  onChange
}) => {
  const [color, setColor] = useState(defaultColor || '#5eabfd');

  const triggerChange = (changedValue) => {
    if (typeof onChange === 'function') {
      onChange(changedValue);
    }
  };

  const onColorChange = (newColor) => {
    setColor(newColor.hex);
    triggerChange(newColor.hex);
  };

  return (
    <Row gutter={8}>
      <Col flex="auto">
        <Input
          type="text"
          className="flex-auto"
          value={value || color}
          onChange={(e) => {
            triggerChange(e.target.value);
          }}
        />
      </Col>

      <Col flex="none">
        <InputColor
          initialValue={value || color}
          placement="right"
          onChange={onColorChange}
          className="flex-none color-input-custom"
        />
      </Col>
    </Row>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  defaultColor: PropTypes.string
};

export default ColorPicker;

